import { BasicPassFragment, ExpireUnit } from 'drycut-graphql';
import { Heading, Para, Stack } from 'ui-components';
import PercentageOff from './PercentageOff';
import { Link } from 'react-router-dom';
import { pluralize } from 'ui-format-utils';
import { twMerge } from 'tailwind-merge';
import PassPrice from './PassPrice';

type Props = {
  pass: BasicPassFragment;
  to: string;
};

export function PassCard({ pass, to }: Props): JSX.Element {
  const { specialPromotion, title, subtitle, timeToExpire, expireUnit } = pass;

  const defaultClasses = 'relative group transition border-2';
  const classes = twMerge(
    defaultClasses,
    specialPromotion
      ? 'border-zinc-800 hover:border-zinc-500 hover:bg-zinc-900/5'
      : 'border-primary-600 hover:border-primary-500 hover:bg-primary-600/10',
  );

  const defaultTitleClasses = 'text-2xl text-primary-600';
  const titleClasses = twMerge(defaultTitleClasses, specialPromotion ? 'text-zinc-800' : '');

  return (
    <Stack as={Link} to={to} className={classes}>
      <PercentageOff pass={pass} />

      <Stack className="p-6 text-center">
        <Heading variant="h4" className={titleClasses}>
          {title}
        </Heading>

        {subtitle && (
          <Heading variant="h4" className="font-aribau">
            {subtitle}
          </Heading>
        )}

        <PassPrice pass={pass} className="mt-2" />

        <Para size="sm" className="text-zinc-500">
          {expireUnit === ExpireUnit.Days
            ? pluralize(timeToExpire, { singular: 'Tag', plural: 'Tage' })
            : pluralize(timeToExpire, { singular: 'Monat', plural: 'Monate' })}{' '}
          gültig
        </Para>
      </Stack>
    </Stack>
  );
}
